var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',_vm._l((_vm.breadcrumbs),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }